export default __webpack_public_path__ + "./images/cc.c075f4e3.png";